/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React, { useContext, useState, useEffect } from "react";
import { Viewer, Worker } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import { pageNavigationPlugin } from "@react-pdf-viewer/page-navigation";
import { getFilePlugin } from "@react-pdf-viewer/get-file";
import { Dashboard2Context } from "./dashboard2";
import isString from "lodash/isString";

import "./MFRReport.css";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";

const PracticeEscalationCriteria = ({ escalationCriteriaPdf }) => {
  const [isValidPDF, setIsValidPDF] = useState(false);
  const { userInfo: interrogationData } = useContext(Dashboard2Context);
  const pageNavigationPluginInstance = pageNavigationPlugin();

  const getFilePluginInstance = getFilePlugin({
    fileNameGenerator: () => `Escalation-criteria-${interrogationData.location.id}.pdf`,
  });

  const { DownloadButton: Download } = getFilePluginInstance;

  useEffect(() => {
    setIsValidPDF(isString(escalationCriteriaPdf) && escalationCriteriaPdf.startsWith("blob:"));
  }, [escalationCriteriaPdf]);

  const renderToolbar = (Toolbar) => (
    <Toolbar>
      {(slots) => {
        const {
          CurrentPageInput,
          EnterFullScreen,
          GoToNextPage,
          GoToPreviousPage,
          NumberOfPages,
          Print,
          ShowSearchPopover,
          Zoom,
          ZoomIn,
          ZoomOut,
        } = slots;
        return (
          <div className="pdf-viewer">
            <ShowSearchPopover title="Search" />
            <div className="pdf-viewer-options page-number ">
              <ZoomOut title="Zoom out" />
              <Zoom />
              <ZoomIn title="Zoom in" />
              <span className="divider" />
              <CurrentPageInput /> / <NumberOfPages />
              <GoToPreviousPage title="Previous page" />
              <GoToNextPage title="Next page" />
            </div>
            <div className="pdf-viewer-options">
              <EnterFullScreen title="Full screen" />
              <Download title="Download" />
              <Print title="Print" />
            </div>
          </div>
        );
      }}
    </Toolbar>
  );
  const defaultLayoutPluginInstance = defaultLayoutPlugin({
    renderToolbar,
    sidebarTabs: (defaultTabs) => [defaultTabs[0]],
  });

  return (
    <>
      <div id="mfr-report-container" className="tab-content mfr-rpt">
        <div className="mfr-main">
          <div className="pdf-container">
            <Worker workerUrl="/ReactPdfWorker.min.js">
              {isValidPDF && (
                <Viewer
                  fileUrl={escalationCriteriaPdf}
                  defaultScale={1.37}
                  plugins={[defaultLayoutPluginInstance, pageNavigationPluginInstance, getFilePluginInstance]}
                  theme={{
                    theme: "dark",
                  }}
                />
              )}
            </Worker>
          </div>
        </div>
      </div>
    </>
  );
};

export default PracticeEscalationCriteria;
